import script from "./trainServicesDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./trainServicesDetail.vue?vue&type=script&setup=true&lang=js"

import "./trainServicesDetail.vue?vue&type=style&index=0&id=7d9c6213&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d9c6213"]])

export default __exports__